import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  BasicMetaData,
  Order,
  OrderFilterModel,
  Sort,
  TalonModelExpectBackend,
  TemplateExpectBackend, TemplateModel,
  TYPE_SEARCH
} from 'shared';
import { PaginateQuery, PaginatorModel, UUID } from 'symbols';
import { TalonModel } from '../symbols';


@Injectable()
export class TalonsService {
  public sortDefault$ = new BehaviorSubject({ sort: Sort.CREATED, order: Order.DESC });

  private readonly apiUrl = '/api/talons';

  constructor(private http: HttpClient) {
  }

  getTalonList(filter?: PaginateQuery<OrderFilterModel>): Observable<PaginatorModel<TalonModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: filter?.filter?.typeSearch || TYPE_SEARCH.BY_METADATA,
      'filter.isNewEquipment': filter?.filter?.isNewEquipment,
      'filter.isUsedEquipment': filter?.filter?.isUsedEquipment
    };

    if (filter?.filter?.typeSearch === TYPE_SEARCH.BY_NUMBER) {
      params['filter.docNumber'] = +filter?.filter?.searchText || '';
    } else {
      params['search'] = filter?.filter?.searchText || '';
    }

    if (filter?.filter?.isDebt) {
      params['isDebt'] = filter?.filter?.isDebt;
    }

    return this.http.get<PaginatorModel<TalonModel>>(this.apiUrl, { params });
  }


  getTalonListLazy(url: string): Observable<PaginatorModel<TalonModel>> {
    return this.http.get<PaginatorModel<TalonModel>>(url);
  }


  getTalonById(id: string): Observable<TalonModel> {
    return this.http.get<TalonModel>(`${this.apiUrl}/talon/${id}`);
  }


  createTalon(talon: TalonModelExpectBackend): Observable<TalonModel> {
    return this.http.post<TalonModel>(`${this.apiUrl}/`, { ...talon });
  }


  getNextMetaData(): Observable<BasicMetaData> {
    return this.http.get<BasicMetaData>(`${this.apiUrl}/next-meta-data`);
  }

  getTalonTemplateList(): Observable<TemplateModel[]> {
    return this.http.get<TemplateModel[]>(`${this.apiUrl}/talon-template-list`);
  }


  updateTemplate(id: string, template: TemplateExpectBackend, name: string): Observable<TemplateModel> {
    return this.http.patch<TemplateModel>(`${this.apiUrl}/talon-template-list/${id}`, { ...template, name });
  }

  createTemplate(name: string, template: TemplateExpectBackend): Observable<TemplateModel> {
    return this.http.post<TemplateModel>(`${this.apiUrl}/talon-template-list/`, { ...template, name });
  }


  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/talon-template-list/${id}`);
  }


  updateTalon(id: UUID, talon: TalonModelExpectBackend, force: boolean): Observable<TalonModel> {
    return this.http.patch<TalonModel>(`${this.apiUrl}/${id}`, { ...talon, force });
  }

  createTalonFromEquipment(equipmentId: UUID): Observable<TalonModel> {
    return this.http.post<TalonModel>(`${this.apiUrl}/create-from-equipment`, { equipmentId });
  }
}
